<template>
    <div>
        <v-card elevation="0">
            <v-card color="#80CBC4" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-table-clock</v-icon>
                    &nbsp;Timetable Controls
                </v-card-title>
            </v-card>
            <Manager />
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/Settings/Timetable/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>